var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m113.412 328.822a14.015 14.015 0 0 1 -14-14v-151.644h-6a14.015 14.015 0 0 0 -14 14v157.644a14.015 14.015 0 0 0 14 14h369.406a14.016 14.016 0 0 0 14-14v-6z",
    fill: "#d4e1f4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2f55d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m454.583 179.413h-32.353a6 6 0 0 0 -6 6v141.174a6 6 0 0 0 6 6h32.353a6 6 0 0 0 6-6v-141.174a6 6 0 0 0 -6-6zm-6 141.174h-20.353v-129.174h20.353z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.818 151.178h-369.406a26.029 26.029 0 0 0 -26 26v29h-18.23a26.029 26.029 0 0 0 -26 26v47.644a26.029 26.029 0 0 0 26 26h18.23v29a26.029 26.029 0 0 0 26 26h369.406a26.029 26.029 0 0 0 26-26v-157.644a26.029 26.029 0 0 0 -26-26zm-413.636 142.644a14.016 14.016 0 0 1 -14-14v-47.644a14.016 14.016 0 0 1 14-14h18.23v75.644zm427.636 41a14.016 14.016 0 0 1 -14 14h-369.406a14.015 14.015 0 0 1 -14-14v-157.644a14.015 14.015 0 0 1 14-14h369.406a14.016 14.016 0 0 1 14 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m394.583 179.413h-32.353a6 6 0 0 0 -6 6v141.174a6 6 0 0 0 6 6h32.353a6 6 0 0 0 6-6v-141.174a6 6 0 0 0 -6-6zm-6 141.174h-20.353v-129.174h20.353z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m340.194 270.978-114.259-69.811a6 6 0 0 0 -9.129 5.12v30.981l-70.396-17.868a6 6 0 0 0 -7.475 5.815v49.97a6 6 0 0 0 4.511 5.815l111.392 28.525a6 6 0 0 0 7.488-5.812v-25.435l74.433 3.812a6 6 0 0 0 3.435-11.112zm-83.561-5.007a6 6 0 0 0 -6.307 5.992v24.019l-99.391-25.452v-37.6l70.4 17.865a6 6 0 0 0 7.475-5.816v-28l84.962 51.921z",
    fill: "#2eca8b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowBattery);
export default __webpack_public_path__ + "static/media/low-battery.15eefd2d93dac9c267f69016ded8836f.svg";
export { ForwardRef as ReactComponent };